import AffiliateLearnerBg from 'assets/Affiliate/Rectangle 40876.png';
import Image from 'next/image';
import React from 'react';

const LearnerJourneyBanner: React.FC = () => {
  return (
    <div className='relative w-full overflow-hidden my-10 md:my-16 py-14 md:py-20 px-4 flex flex-col items-center justify-center text-center'>
      {/* Background Image */}
      <Image
        src={AffiliateLearnerBg}
        alt='Learners on their learning journey'
        fill
        className='object-cover object-center z-0 pointer-events-none select-none'
        priority
      />

      {/* Dark top/side vignette & rich primary orange gradient */}
      <div
        className='absolute inset-0 z-10 pointer-events-none'
        style={{
          background: `
            linear-gradient(180deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.15) 35%, rgba(0, 0, 0, 0.2) 100%),
            radial-gradient(ellipse 110% 90% at 50% 115%, rgba(255, 86, 18, 0.92) 0%, rgba(255, 86, 18, 0.5) 35%, rgba(255, 86, 18, 0.15) 60%, rgba(0, 0, 0, 0) 80%)
          `,
        }}
      />
      {/* Ambient bottom glow matching primary #FF5612 */}
      <div
        className='absolute bottom-0 left-0 right-0 h-3/5 z-10 pointer-events-none'
        style={{
          background:
            'linear-gradient(to top, rgba(255, 86, 18, 0.7) 0%, rgba(255, 86, 18, 0.28) 45%, rgba(255, 86, 18, 0.05) 75%, transparent 100%)',
        }}
      />

      {/* Content */}
      <div className='relative z-20 max-w-3xl mx-auto flex flex-col items-center gap-2 md:gap-3 px-4'>
        <h2 className='text-xl sm:text-2xl md:text-3xl lg:text-[32px] md:leading-[42px] leading-snug font-normal text-white tracking-tight'>
          Join <span className='text-primary font-bold'>220k+</span> learners on their learning journey
        </h2>
        <p className='text-xs sm:text-sm md:text-base text-[#E5E5E5] max-w-2xl font-normal leading-relaxed opacity-90'>
          Unlock premium learning experiences and join thousands who are upgrading their skills with ZebraLearn.
        </p>
      </div>
    </div>
  );
};

export default LearnerJourneyBanner;
